module.exports = __webpack_public_path__ + "static/media/Expertise1.92fb9f44.png";